import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from 'src/app/app-config.loader';
import { PassaggioConsegneRequest, PassaggioConsegneResponse } from '../models/passaggio-consegne.model';
import { Observable } from 'rxjs';


@Injectable()
export class PassaggioConsegneService {

  private readonly apiBaseUrl: string;

  constructor(private readonly appConfig: AppConfig, private readonly http: HttpClient) {
    this.apiBaseUrl = `${appConfig.settings.apiRoot}`;
  }

  public getByPassaggioConsegneId(passaggioConsegneId: number): Observable<PassaggioConsegneResponse> {
    return this.http.get<PassaggioConsegneResponse>(`${this.apiBaseUrl}/passaggioconsegne/${passaggioConsegneId}`);
  }

  public getAll(from:Date|null, to:Date|null): Observable<PassaggioConsegneResponse[]> {
    let params = new HttpParams();

    if ( from) {
      params = params.append( 'from', from.toISOString());
    }
    if ( to) {
      params = params.append( 'to', to.toISOString());
    }        

    return this.http.get<PassaggioConsegneResponse[]>(`${this.apiBaseUrl}/passaggioconsegne`, {params:params});
  }

  public getUltimo(): Observable<PassaggioConsegneResponse> {
    return this.http.get<PassaggioConsegneResponse>(`${this.apiBaseUrl}/passaggioconsegne/ultimoPassaggio`);
  }

  public add(passaggioConsegne: PassaggioConsegneRequest): Observable<PassaggioConsegneResponse> {    
    return this.http.post<PassaggioConsegneResponse>(`${this.apiBaseUrl}/passaggioconsegne`, passaggioConsegne);
  }

  public update(passaggioConsegne: PassaggioConsegneRequest, id: number): Observable<PassaggioConsegneResponse> {
    return this.http.put<PassaggioConsegneResponse>(`${this.apiBaseUrl}/passaggioconsegne/${id}`, passaggioConsegne);
  }
}

